import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createSlots as _createSlots, createBlock as _createBlock, vShow as _vShow, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "registration-culture-table" };
const _hoisted_2 = { class: "card-title d-flex align-items-center" };
const _hoisted_3 = {
    key: 0,
    class: "config-options-header"
};
const _hoisted_4 = { class: "btn-options" };
const _hoisted_5 = { class: "btn-options" };
const _hoisted_6 = { class: "export-wrapper" };
const _hoisted_7 = { class: "registration-culture-table__modal-table" };
const _hoisted_8 = { class: "el-table__column" };
const _hoisted_9 = { style: { "text-align": "right" } };
const _hoisted_10 = { class: "registration-culture-table__page-table" };
const _hoisted_11 = { key: 0 };
const _hoisted_12 = { class: "config-options-header" };
const _hoisted_13 = { class: "btn-options" };
const _hoisted_14 = { class: "export-wrapper" };
const _hoisted_15 = ["onClick"];
const _hoisted_16 = { class: "el-table__column" };
const _hoisted_17 = { style: { "text-align": "right" } };
import { reactive, computed, watch } from 'vue';
import vSelect from 'vue-select';
import { useStore } from 'vuex';
import bus from '@/helpers/events/bus';
import HeaderDatepicker from '@/components/menu/_organisms/HeaderDatepicker.vue';
import BaseLoader from '@/components/_atoms/BaseLoaderSpinner.vue';
import ListPagination from '@/components/_atoms/ListPagination.vue';
import InfoCard from '@/components/_atoms/InfoCard.vue';
import RegistrationCultureExportTable from './RegistrationCultureExportTable.vue';
import { fetchTable } from '../data/fetchTable';
import { fetchTablePresets } from '../data/fetchTablePresets';
import { checkThreshold, formatValue, formatDataTable, getWidth, getMask, getPlaceholder } from '../utils/table';
import { useMixpanelConfig } from '@/utilities/mixpanel';
import { useMixpanelCultureReportSearch, useMixpanelCultureReportSelectedTable, useMixpanelCultureReportSort, } from '@/utilities/mixpanel/registrationCulture';
import Alert from '@/components/_atoms/Alert.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'RegistrationCultureTable',
    setup(__props) {
        const state = reactive({
            selectedOption: { id: 'store', name: '' },
            tablePresets: {
                date_year_month: '',
                store: '',
                fictitious_marked_orders: '',
            },
            pagination: {
                limit: 20,
                page: 1,
                count: 0,
            },
            modalVisible: false,
            loading: false,
            search: {},
            tableHeader: [],
            hasError: false,
            columnsFiltered: [],
            id: 'registration-culture-report',
            sort: {
                prop: 'fictitious_rate',
                order: 'descending',
                numberOfClicks: 0,
                orderBy: '-fictitious_rate, total_orders, store_name',
            },
            defaultOrdering: {
                date_year_month: '-order_year_month, -fictitious_rate, total_orders, store_name',
                store: '-fictitious_rate, total_orders, store_name',
                fictitious_marked_orders: '-customer_id, order_date, order_id',
            },
            isSearchTable: false,
            tableData: {
                rows: [],
                filtered: [],
            },
            isExportVisible: false,
        });
        const store = useStore();
        // Computed
        const selectedDates = computed(() => store.getters.dates);
        const user = computed(() => store.getters.user);
        const getQuery = computed(() => state.columnsFiltered.length
            ? JSON.stringify(state.columnsFiltered.map(result => ({ column: result.column, value: result.value })))
            : '');
        const getColumns = computed(() => {
            return state.tableHeader.map(column => ({
                key: column.key,
                label: column.name,
                type: column.type,
                threshold: column?.threshold ?? [],
                isMetric: column.isMetric,
            }));
        });
        const getColumnsToSearch = computed(() => {
            const columnsToSearch = getColumns.value.filter(column => !column.isMetric);
            const result = {
                no_label: columnsToSearch.map(c => c.key),
                with_label: columnsToSearch.map(c => ({ key: c.key, label: c.label })),
            };
            return result;
        });
        // Resets
        const resetOrdering = (value = '') => {
            state.sort = {
                prop: state.defaultOrdering[state.selectedOption.id].split(',')[0].replace('-', ''),
                order: value === 'removeOrderBy' ? '' : 'descending',
                numberOfClicks: 0,
                orderBy: value === 'removeOrderBy' ? '' : state.defaultOrdering[state.selectedOption.id],
            };
        };
        const resetPagination = () => {
            state.pagination.page = 1;
        };
        const resetFilter = (column) => {
            state.columnsFiltered = state.columnsFiltered.filter(col => col.column !== column);
            state.search[column] = '';
            fetchDataTable('search');
        };
        // Sorting
        const sortTable = ({ prop }) => {
            state.sort.numberOfClicks = state.sort.prop === prop ? (state.sort.numberOfClicks += 1) : 0;
            if (state.sort.numberOfClicks === 2) {
                resetOrdering('removeOrderBy');
                fetchDataTable();
                return;
            }
            const isDefaultOrder = state.sort.orderBy && !state.sort.orderBy.includes('-') && state.sort.prop === prop;
            state.sort.prop = prop;
            if (isDefaultOrder) {
                state.sort.orderBy = `-${prop}`;
                state.sort.order = 'descending';
            }
            if (!state.sort.orderBy || !isDefaultOrder) {
                state.sort.orderBy = prop;
                state.sort.order = 'ascending';
            }
            useMixpanelCultureReportSort('view_oto-registration-culture_sort', prop, state.sort.order);
            fetchDataTable();
        };
        const isExporting = value => {
            bus.$emit('render-page-loader', value);
        };
        // Search
        const doesColumnExist = (column, columnsFiltered) => {
            return columnsFiltered.some(col => col.column === column);
        };
        const removeColumnIfExists = (column, columnsFiltered) => {
            return columnsFiltered.filter(col => col.column !== column);
        };
        const addColumnAndFetch = (column, value) => {
            state.columnsFiltered.push({ column, value });
            fetchDataTable('search');
        };
        const searchByColumn = (column, value) => {
            const { columnsFiltered } = state;
            if (doesColumnExist(column, columnsFiltered)) {
                state.columnsFiltered = removeColumnIfExists(column, columnsFiltered);
            }
            useMixpanelCultureReportSearch('view_oto-registration-culture_search-table', column, value);
            addColumnAndFetch(column, value);
        };
        // Styles and Formatters
        const tableRowClassName = ({ row, column, columnIndex }) => {
            const threshold = getColumns.value[columnIndex]['threshold'];
            const isMetric = getColumns.value[columnIndex]['isMetric'] ? 'metric' : 'dimension';
            return `threshold ${isMetric} ${checkThreshold({
                amount: row[column.property],
                threshold: threshold.map(value => Number(value) * 100),
            })}`;
        };
        const tableHeaderClassName = ({ columnIndex }) => {
            const sort = getColumns.value[columnIndex]['key'] === state.sort.prop ? state.sort.order : '';
            const isMetric = getColumns.value[columnIndex]['isMetric'] ? 'metric' : 'dimension';
            return `${sort} ${isMetric}`;
        };
        const formatter = (row, column) => {
            const SEARCH_COLUMNS = [
                'store_name',
                'order_year_month',
                'order_store',
                'cluster',
                'order_date',
                'order_id',
                'order_store_name',
                'customer_id',
                'full_name',
                'document_number',
                'pref_store',
                'pref_store_name',
            ];
            const typeColumn = getColumns.value.filter(col => col.key === column.property)[0]['type'];
            const typeValue = SEARCH_COLUMNS.includes(column.property) ? 'default' : typeColumn;
            return formatValue({ type: typeValue, amount: row[column.property] });
        };
        // Helpers
        const getColumnName = (key) => {
            return getColumns.value.filter(column => column.key === key)[0]['label'];
        };
        const expandTable = () => {
            state.modalVisible = true;
            useMixpanelConfig('view_oto-registration-culture_expand-table');
        };
        // Presets
        const triggerPresetFormat = (presets) => {
            if (!presets)
                return;
            const result = Object.entries(presets).map(preset => ({ id: preset[0], name: preset[1] }));
            return result;
        };
        // Fetch
        const fetchDataTable = async (typeFetch) => {
            state.loading = true;
            state.isSearchTable = false;
            if (typeFetch === 'search') {
                state.isSearchTable = true;
                resetPagination();
            }
            if (typeFetch === 'preset') {
                state.search = {};
                state.columnsFiltered = [];
                resetOrdering();
                resetPagination();
            }
            const params = {
                preset: state.selectedOption.id,
                page: state.pagination.page,
                limit: state.pagination.limit,
                dates: selectedDates.value,
                orderBy: state.sort.orderBy,
                query: '',
            };
            if (getQuery.value.length && typeFetch !== 'preset')
                params.query = getQuery.value;
            await fetchTable(params)
                .then(response => {
                if (!response.data.length && typeFetch !== 'search') {
                    state.tableData.filtered = [];
                    state.tableData.rows = [];
                    state.pagination.count = response.totalCount;
                    return;
                }
                const data = formatDataTable(response.data, response.series);
                state.tableData.rows = data;
                state.tableData.filtered = state.tableData.rows;
                state.tableHeader = response.series;
                state.pagination.count = response.totalCount;
            })
                .catch(() => {
                state.hasError = true;
            })
                .finally(() => {
                state.loading = false;
            });
        };
        const selectedPreset = () => {
            useMixpanelCultureReportSelectedTable('view_oto-registration-culture_change-aggregation', state.selectedOption.id);
            fetchDataTable('preset');
            resetOrdering();
        };
        const fetchDataTablePresets = () => {
            fetchTablePresets().then((presets) => {
                const selectedPreset = state.selectedOption.id;
                state.selectedOption = { id: selectedPreset, name: presets[selectedPreset] };
                state.tablePresets = presets;
            });
        };
        const initialize = () => {
            fetchDataTable();
            fetchDataTablePresets();
        };
        watch(selectedDates.value, () => {
            initialize();
        });
        initialize();
        return (_ctx, _cache) => {
            const _component_base_card_header = _resolveComponent("base-card-header");
            const _component_el_input = _resolveComponent("el-input");
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_popover = _resolveComponent("el-popover");
            const _component_el_table_column = _resolveComponent("el-table-column");
            const _component_el_table = _resolveComponent("el-table");
            const _component_el_dialog = _resolveComponent("el-dialog");
            const _component_base_card_v2 = _resolveComponent("base-card-v2");
            const _directive_mask = _resolveDirective("mask");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_base_card_v2, {
                    class: _normalizeClass(state.loading || !state.tableHeader.length ? 'registration-culture-table__card' : '')
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_el_dialog, {
                            class: "dialog-metrics",
                            modelValue: state.modalVisible,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((state.modalVisible) = $event)),
                            fullscreen: "",
                            height: "70vh",
                            width: "100%"
                        }, {
                            header: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, [
                                    _createVNode(_component_base_card_header, {
                                        title: _ctx.$t('metrics'),
                                        icon: "icon-table-30px"
                                    }, null, 8, ["title"])
                                ]),
                                (!state.loading && state.tableHeader.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                        _createElementVNode("div", _hoisted_4, [
                                            _createVNode(_unref(vSelect), {
                                                id: "dash-metrics-select",
                                                modelValue: state.selectedOption,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((state.selectedOption) = $event)),
                                                label: "name",
                                                class: "registration-culture-table__metrics",
                                                clearable: false,
                                                options: triggerPresetFormat(state.tablePresets),
                                                placeholder: _ctx.$t('select'),
                                                "onOption:selected": _cache[1] || (_cache[1] = ($event) => (fetchDataTable('preset')))
                                            }, {
                                                option: _withCtx(({ name }) => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t(`${name}`)), 1)
                                                ]),
                                                "selected-option": _withCtx(({ name }) => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t(`${name}`)), 1)
                                                ]),
                                                "open-indicator": _withCtx(({ attributes }) => [
                                                    _createElementVNode("span", _mergeProps(attributes, { class: "arrow-down" }), null, 16)
                                                ]),
                                                "no-options": _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t('no-results')), 1)
                                                ]),
                                                _: 1
                                            }, 8, ["modelValue", "options", "placeholder"]),
                                            _createVNode(HeaderDatepicker, {
                                                language: user.value.language,
                                                route: "base-management/registration-culture"
                                            }, null, 8, ["language"])
                                        ]),
                                        _createElementVNode("div", _hoisted_5, [
                                            _createElementVNode("div", _hoisted_6, [
                                                _createVNode(RegistrationCultureExportTable, {
                                                    onIsLoadingExport: isExporting,
                                                    preset: state.selectedOption.id,
                                                    dates: selectedDates.value,
                                                    query: getQuery.value
                                                }, null, 8, ["preset", "dates", "query"])
                                            ])
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_7, [
                                    _withDirectives(_createVNode(_component_el_table, {
                                        data: state.tableData.filtered,
                                        "scrollbar-always-on": true,
                                        "cell-class-name": tableRowClassName,
                                        "header-cell-class-name": tableHeaderClassName,
                                        style: { "width": "100%" },
                                        height: "75vh",
                                        stripe: "",
                                        "empty-text": ' ',
                                        "default-sort": state.sort,
                                        onSortChange: sortTable
                                    }, {
                                        empty: _withCtx(() => [
                                            _createVNode(InfoCard, {
                                                class: "registration-culture-table__empty-table",
                                                ref: "message-error",
                                                error: state.hasError
                                            }, null, 8, ["error"])
                                        ]),
                                        default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getColumns.value, (column, index) => {
                                                return (_openBlock(), _createBlock(_component_el_table_column, {
                                                    key: index,
                                                    sortable: "",
                                                    fixed: index === 0 ?? true,
                                                    formatter: formatter,
                                                    prop: column.key,
                                                    label: column.label,
                                                    "min-width": _unref(getWidth)(column.key)
                                                }, _createSlots({ _: 2 }, [
                                                    (getColumnsToSearch.value.no_label.includes(column.key))
                                                        ? {
                                                            name: "header",
                                                            fn: _withCtx(() => [
                                                                _createElementVNode("div", _hoisted_8, [
                                                                    _createElementVNode("label", null, _toDisplayString(getColumnName(column.key)), 1),
                                                                    _createVNode(_component_el_popover, {
                                                                        trigger: "hover",
                                                                        placement: "bottom",
                                                                        width: 260
                                                                    }, {
                                                                        reference: _withCtx(() => [
                                                                            _createElementVNode("i", {
                                                                                class: _normalizeClass([{
                                                                                        'color-oto-brand-omni': state.columnsFiltered.map(col => col.column).includes(column.key),
                                                                                    }, "icon icon-search-12px ml--4"])
                                                                            }, null, 2)
                                                                        ]),
                                                                        default: _withCtx(() => [
                                                                            _withDirectives(_createVNode(_component_el_input, {
                                                                                modelValue: state.search[column.key],
                                                                                "onUpdate:modelValue": ($event) => ((state.search[column.key]) = $event),
                                                                                placeholder: _unref(getPlaceholder)(column.key),
                                                                                size: "small",
                                                                                ref_for: true,
                                                                                ref: column.key,
                                                                                onKeyup: _withKeys(($event) => (searchByColumn(column.key, state.search[column.key], index)), ["enter"])
                                                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "onKeyup"]), [
                                                                                [_directive_mask, _unref(getMask)(column.key)]
                                                                            ]),
                                                                            _createElementVNode("div", _hoisted_9, [
                                                                                _createVNode(_component_el_button, {
                                                                                    round: "",
                                                                                    size: "small",
                                                                                    text: "",
                                                                                    onClick: ($event) => (resetFilter(column.key, index)),
                                                                                    disabled: !state.search[column.key]
                                                                                }, {
                                                                                    default: _withCtx(() => [
                                                                                        _createTextVNode(_toDisplayString(state.search[column.key] ? 'limpar filtro' : 'cancelar'), 1)
                                                                                    ]),
                                                                                    _: 2
                                                                                }, 1032, ["onClick", "disabled"]),
                                                                                _createVNode(_component_el_button, {
                                                                                    disabled: !state.search[column.key],
                                                                                    round: "",
                                                                                    size: "small",
                                                                                    type: "primary",
                                                                                    onClick: ($event) => (searchByColumn(column.key, state.search[column.key], index))
                                                                                }, {
                                                                                    default: _withCtx(() => [
                                                                                        _createTextVNode("pesquisar")
                                                                                    ]),
                                                                                    _: 2
                                                                                }, 1032, ["disabled", "onClick"])
                                                                            ])
                                                                        ]),
                                                                        _: 2
                                                                    }, 1024)
                                                                ])
                                                            ]),
                                                            key: "0"
                                                        }
                                                        : (!getColumnsToSearch.value.no_label.includes(column.key) &&
                                                            state.selectedOption.id !== 'fictitious_marked_orders')
                                                            ? {
                                                                name: "header",
                                                                fn: _withCtx(() => [
                                                                    _createElementVNode("div", { class: "el-table__column" }, [
                                                                        _createElementVNode("label", null, _toDisplayString(getColumnName(column.key)), 1),
                                                                        _createVNode(_component_el_popover, {
                                                                            trigger: "hover",
                                                                            placement: "top",
                                                                            width: 260,
                                                                            class: "registration-culture-table__tooltip"
                                                                        }, {
                                                                            reference: _withCtx(() => [
                                                                                _createElementVNode("i", { class: "icon icon-question-12px" })
                                                                            ]),
                                                                            default: _withCtx(() => [
                                                                                _createElementVNode("p", {
                                                                                    innerHTML: _ctx.$t(`registration-culture.table.tooltips.${column.key}`)
                                                                                }, null, 8, ["innerHTML"])
                                                                            ]),
                                                                            _: 2
                                                                        }, 1024)
                                                                    ])
                                                                ]),
                                                                key: "1"
                                                            }
                                                            : undefined
                                                ]), 1032, ["fixed", "prop", "label", "min-width"]));
                                            }), 128))
                                        ]),
                                        _: 1
                                    }, 8, ["data", "default-sort"]), [
                                        [_vShow, (!state.loading && state.tableData.rows.length) || (!state.loading && state.isSearchTable)]
                                    ]),
                                    (!state.loading)
                                        ? (_openBlock(), _createBlock(ListPagination, {
                                            key: 0,
                                            data: state.pagination,
                                            limit: state.pagination.limit,
                                            "limit-range": [5, 10, 20, 30, 50],
                                            identify: state.id,
                                            "show-list-pages": false,
                                            "show-quantity-lines": true,
                                            onChangePage: fetchDataTable
                                        }, null, 8, ["data", "limit", "identify"]))
                                        : _createCommentVNode("", true),
                                    (state.loading)
                                        ? (_openBlock(), _createBlock(BaseLoader, { key: 1 }))
                                        : _createCommentVNode("", true),
                                    (!state.tableData.filtered.length && !state.loading && !state.columnsFiltered.length)
                                        ? (_openBlock(), _createBlock(InfoCard, {
                                            key: 2,
                                            ref: "message-error",
                                            error: state.hasError
                                        }, null, 8, ["error"]))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_10, [
                            (!state.loading && state.tableHeader.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _createVNode(_component_base_card_header, {
                                        title: _ctx.$t('metrics'),
                                        icon: "icon-table-30px"
                                    }, null, 8, ["title"]),
                                    _createElementVNode("div", _hoisted_12, [
                                        _createVNode(_unref(vSelect), {
                                            id: "dash-metrics-select",
                                            modelValue: state.selectedOption,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((state.selectedOption) = $event)),
                                            label: "name",
                                            class: "registration-culture-table__metrics",
                                            clearable: false,
                                            options: triggerPresetFormat(state.tablePresets),
                                            placeholder: _ctx.$t('select'),
                                            "onOption:selected": selectedPreset
                                        }, {
                                            option: _withCtx(({ name }) => [
                                                _createTextVNode(_toDisplayString(_ctx.$t(`${name}`)), 1)
                                            ]),
                                            "selected-option": _withCtx(({ name }) => [
                                                _createTextVNode(_toDisplayString(_ctx.$t(`${name}`)), 1)
                                            ]),
                                            "open-indicator": _withCtx(({ attributes }) => [
                                                _createElementVNode("span", _mergeProps(attributes, { class: "arrow-down" }), null, 16)
                                            ]),
                                            "no-options": _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('no-results')), 1)
                                            ]),
                                            _: 1
                                        }, 8, ["modelValue", "options", "placeholder"]),
                                        _createElementVNode("div", _hoisted_13, [
                                            _createElementVNode("div", _hoisted_14, [
                                                _createVNode(RegistrationCultureExportTable, {
                                                    onIsLoadingExport: isExporting,
                                                    preset: state.selectedOption.id,
                                                    dates: selectedDates.value,
                                                    query: getQuery.value
                                                }, null, 8, ["preset", "dates", "query"]),
                                                _createElementVNode("button", {
                                                    ref: "button",
                                                    class: "btn export",
                                                    onClick: _withModifiers(expandTable, ["prevent"])
                                                }, _toDisplayString(_ctx.$t('dashboard.expand-table')), 9, _hoisted_15)
                                            ])
                                        ])
                                    ]),
                                    (state.selectedOption.id === 'fictitious_marked_orders')
                                        ? (_openBlock(), _createBlock(Alert, {
                                            key: 0,
                                            class: "registration-culture-table__alert",
                                            type: "secondary",
                                            message: _ctx.$t('registration-culture.table.alert')
                                        }, null, 8, ["message"]))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true),
                            _withDirectives(_createVNode(_component_el_table, {
                                data: state.tableData.filtered,
                                "scrollbar-always-on": true,
                                "cell-class-name": tableRowClassName,
                                "header-cell-class-name": tableHeaderClassName,
                                style: { "width": "100%" },
                                stripe: "",
                                "empty-text": ' ',
                                "default-sort": state.sort,
                                onSortChange: sortTable
                            }, {
                                empty: _withCtx(() => [
                                    _createVNode(InfoCard, {
                                        class: "registration-culture-table__empty-table",
                                        ref: "message-error",
                                        error: state.hasError
                                    }, null, 8, ["error"])
                                ]),
                                default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getColumns.value, (column, index) => {
                                        return (_openBlock(), _createBlock(_component_el_table_column, {
                                            key: index,
                                            sortable: "",
                                            fixed: index === 0 ?? true,
                                            formatter: formatter,
                                            prop: column.key,
                                            label: column.label,
                                            "min-width": _unref(getWidth)(column.key)
                                        }, _createSlots({ _: 2 }, [
                                            (getColumnsToSearch.value.no_label.includes(column.key))
                                                ? {
                                                    name: "header",
                                                    fn: _withCtx(() => [
                                                        _createElementVNode("div", _hoisted_16, [
                                                            _createElementVNode("label", null, _toDisplayString(getColumnName(column.key)), 1),
                                                            _createVNode(_component_el_popover, {
                                                                trigger: "hover",
                                                                placement: "bottom",
                                                                width: 260
                                                            }, {
                                                                reference: _withCtx(() => [
                                                                    _createElementVNode("i", {
                                                                        class: _normalizeClass([{
                                                                                'color-oto-brand-omni': state.columnsFiltered.map(col => col.column).includes(column.key),
                                                                            }, "icon icon-search-12px ml--4"])
                                                                    }, null, 2)
                                                                ]),
                                                                default: _withCtx(() => [
                                                                    _withDirectives(_createVNode(_component_el_input, {
                                                                        modelValue: state.search[column.key],
                                                                        "onUpdate:modelValue": ($event) => ((state.search[column.key]) = $event),
                                                                        placeholder: _unref(getPlaceholder)(column.key),
                                                                        size: "small",
                                                                        ref_for: true,
                                                                        ref: column.key,
                                                                        onKeyup: _withKeys(($event) => (searchByColumn(column.key, state.search[column.key], index)), ["enter"])
                                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "onKeyup"]), [
                                                                        [_directive_mask, _unref(getMask)(column.key)]
                                                                    ]),
                                                                    _createElementVNode("div", _hoisted_17, [
                                                                        _createVNode(_component_el_button, {
                                                                            round: "",
                                                                            size: "small",
                                                                            text: "",
                                                                            onClick: ($event) => (resetFilter(column.key, index)),
                                                                            disabled: !state.search[column.key]
                                                                        }, {
                                                                            default: _withCtx(() => [
                                                                                _createTextVNode(_toDisplayString(state.search[column.key] ? 'limpar filtro' : 'cancelar'), 1)
                                                                            ]),
                                                                            _: 2
                                                                        }, 1032, ["onClick", "disabled"]),
                                                                        _createVNode(_component_el_button, {
                                                                            disabled: !state.search[column.key],
                                                                            round: "",
                                                                            size: "small",
                                                                            type: "primary",
                                                                            onClick: ($event) => (searchByColumn(column.key, state.search[column.key], index))
                                                                        }, {
                                                                            default: _withCtx(() => [
                                                                                _createTextVNode("pesquisar")
                                                                            ]),
                                                                            _: 2
                                                                        }, 1032, ["disabled", "onClick"])
                                                                    ])
                                                                ]),
                                                                _: 2
                                                            }, 1024)
                                                        ])
                                                    ]),
                                                    key: "0"
                                                }
                                                : (!getColumnsToSearch.value.no_label.includes(column.key) &&
                                                    state.selectedOption.id !== 'fictitious_marked_orders')
                                                    ? {
                                                        name: "header",
                                                        fn: _withCtx(() => [
                                                            _createElementVNode("div", { class: "el-table__column" }, [
                                                                _createElementVNode("label", null, _toDisplayString(getColumnName(column.key)), 1),
                                                                _createVNode(_component_el_popover, {
                                                                    trigger: "hover",
                                                                    placement: "top",
                                                                    width: 260,
                                                                    class: "registration-culture-table__tooltip"
                                                                }, {
                                                                    reference: _withCtx(() => [
                                                                        _createElementVNode("i", { class: "icon icon-question-12px" })
                                                                    ]),
                                                                    default: _withCtx(() => [
                                                                        _createElementVNode("p", {
                                                                            innerHTML: _ctx.$t(`registration-culture.table.tooltips.${column.key}`)
                                                                        }, null, 8, ["innerHTML"])
                                                                    ]),
                                                                    _: 2
                                                                }, 1024)
                                                            ])
                                                        ]),
                                                        key: "1"
                                                    }
                                                    : undefined
                                        ]), 1032, ["fixed", "prop", "label", "min-width"]));
                                    }), 128))
                                ]),
                                _: 1
                            }, 8, ["data", "default-sort"]), [
                                [_vShow, (!state.loading && state.tableData.rows.length) || (!state.loading && state.isSearchTable)]
                            ]),
                            (!state.loading || !state.pagination.count)
                                ? (_openBlock(), _createBlock(ListPagination, {
                                    key: 1,
                                    data: state.pagination,
                                    limit: state.pagination.limit,
                                    "limit-range": [5, 10, 20, 30, 50],
                                    identify: state.id,
                                    "show-list-pages": false,
                                    "show-quantity-lines": true,
                                    onChangePage: fetchDataTable
                                }, null, 8, ["data", "limit", "identify"]))
                                : _createCommentVNode("", true),
                            (state.loading)
                                ? (_openBlock(), _createBlock(BaseLoader, { key: 2 }))
                                : _createCommentVNode("", true),
                            (!state.tableData.filtered.length && !state.loading && !state.columnsFiltered.length)
                                ? (_openBlock(), _createBlock(InfoCard, {
                                    key: 3,
                                    ref: "message-error",
                                    error: state.hasError
                                }, null, 8, ["error"]))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _: 1
                }, 8, ["class"])
            ]));
        };
    }
});
